import React from 'react';
import ReactDOM from 'react-dom/client';

// import 'regenerator-runtime/runtime';

import App from './App';
import './index.css';

import loadDynamicConfig from './loadDynamicConfig';
import { extensions as defaultExtensions, modes as defaultModes } from './pluginImports';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

loadDynamicConfig(window.config).then((config_json: object) => {
	// Reset Dynamic config if defined
	if (config_json !== null) {
		window.config = config_json;
	}

	/**
	 * Combine our appConfiguration with installed extensions and modes.
	 * In the future appConfiguration may contain modes added at runtime.
	 *  */
	const appProps = {
		config: window ? window.config : {},
		defaultExtensions,
		defaultModes,
	};

	const root = ReactDOM.createRoot(document.getElementById('root'));
	root.render(
		// <React.StrictMode>
		<App {...appProps} />,
		// </React.StrictMode>
	);

	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: https://bit.ly/CRA-PWA
	serviceWorkerRegistration.register();
});

reportWebVitals();
